import { SvgIcon } from '@mui/material';

const ToShop = props => (
  <SvgIcon
    width='33.172'
    height='32.971'
    viewBox='0 0 33.172 32.971'
    {...props}
  >
    <g id='Group_39' data-name='Group 39'>
      <path
        id='Path_19'
        data-name='Path 19'
        d='M34.126,6.552H1.12a3.065,3.065,0,0,1,.225-.6l2.417-4.6A2.467,2.467,0,0,1,5.954,0H29.293a2.467,2.467,0,0,1,2.192,1.355l2.417,4.6A3.066,3.066,0,0,1,34.126,6.552Z'
        transform='translate(-1.037)'
        fill='#dc0032'
      />
      <path
        id='Path_20'
        data-name='Path 20'
        d='M62.193,192.2a5.818,5.818,0,0,1-1.173.121,5.688,5.688,0,0,1-4.119-1.805,5.766,5.766,0,0,1-4.167,1.805,5.7,5.7,0,0,1-4.125-1.806,5.765,5.765,0,0,1-4.168,1.806,5.7,5.7,0,0,1-4.124-1.805,5.757,5.757,0,0,1-4.162,1.805,5.92,5.92,0,0,1-1.179-.121c-.143-.029-.276-.087-.416-.127v13.986a2.557,2.557,0,0,0,2.5,2.623h2.422V196.619a1.034,1.034,0,0,1,1.008-1.058h6.094a1.034,1.034,0,0,1,1.008,1.058V208.68H60.115a2.557,2.557,0,0,0,2.5-2.623V192.07c-.141.041-.276.1-.422.128m-4.5,8.141a1.034,1.034,0,0,1-1.008,1.058H53.139a1.034,1.034,0,0,1-1.008-1.058v-3.721a1.034,1.034,0,0,1,1.008-1.058h3.546a1.034,1.034,0,0,1,1.008,1.058Z'
        transform='translate(-32.001 -175.708)'
        fill='#dc0032'
      />
      <path
        id='Path_21'
        data-name='Path 21'
        d='M33.089,108.2H.083c-.028,0-.054-.009-.083-.01v1.825a4.414,4.414,0,0,0,3.317,4.426,4.207,4.207,0,0,0,4.976-4.264,4.257,4.257,0,0,0,4.147,4.351,4.257,4.257,0,0,0,4.147-4.351,4.257,4.257,0,0,0,4.147,4.351,4.257,4.257,0,0,0,4.147-4.351,4.207,4.207,0,0,0,4.976,4.264,4.414,4.414,0,0,0,3.317-4.426v-1.825c-.028,0-.054.01-.083.01'
        transform='translate(0 -99.785)'
        fill='#dc0032'
      />
    </g>
  </SvgIcon>
);

export default ToShop;
